export const redirectToAppDownload = (iosLink, androidLink, fallbackAction) => {
    const userAgent = navigator.userAgent;
    const isIos = /iPad|iPhone|iPod/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isAndroid = /android/i.test(userAgent);
    if (isAndroid) {
        window.location.assign(androidLink);
    }
    else if (isIos) {
        window.location.assign(iosLink);
    }
    else {
        fallbackAction?.();
    }
};
//# sourceMappingURL=redirectToAppDownload.js.map